
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { loadCountries, loadPatientResultPref, loadUrgentResultPref } from '../../utilities/httpRequest';
import { validMail, validEmpty, validPassword, validPhone } from '../../utilities/valid';
import NextArrow from '../../components/NextArrow';
import AlertWindow from '../../components/AlertWindow';
import InputText from '../../components/InputText';
import InputPhone from '../../components/InputPhone';
import InputSelect from '../../components/InputSelect';
import { useNavigate } from 'react-router-dom';

export default function Inscription() {

    const [displayAlertWindow, setDisplayAlertWindow] = useState(false);

    const [tab, setTab] = useState(1);

    const [data, setData] = useState({
        email: {
            value: "",
            valid: ""
        },
        password: {
            value: "",
            valid: ""
        },
        name: {
            value: "",
            valid: ""
        },
        firstname: {
            value: "",
            valid: ""
        },
        phone: {
            value: "",
            valid: ""
        },
        street: {
            value: "",
            valid: ""
        },
        streetNb: {
            value: "",
            valid: ""
        },
        postalCode: {
            value: "",
            valid: ""
        },
        box: {
            value: "",
            valid: ""
        },
        country: {
            value: "",
            valid: ""
        },
        language: {
            value: "",
            valid: ""
        },
        orgNb: {
            value: "",
            valid: ""
        },
        structureVete: [],
        patient_result_preference: {
            value: "",
            valid: ""
        },
        urgent_result_preference: {
            value: [],
            valid: ""
        },
        cg: {
            value: false,
            valid: ""
        },
        newsletter: {
            value: false,
            valid: ""
        }

    });

    const setTab2 = () => {
        const validateField = () => {
            let validation = true;
            let dataTmp = { ...data };
            //Email validation
            if (!validEmpty(data.email.value)) {
                dataTmp.email.valid = "Requis";
                validation = false;
            } else if (!validMail(data.email.value)) {
                dataTmp.email.valid = "Email invalide";
                validation = false;
            }
            //Password validation
            if (!validEmpty(data.password.value)) {
                dataTmp.password.valid = "Requis";
                validation = false;
            } else if (!validPassword(data.password.value)) {
                dataTmp.password.valid = "Mot de passe invalide";
                validation = false;
            }
            setData(dataTmp);
            return validation;
        }

        if (validateField()) {
            setTab(2);
        }
    }

    const setTab3 = () => {

        const validateField = () => {
            let validation = true;
            let dataTmp = { ...data };
            //Phone validation
            if (!validEmpty(data.phone.value)) {
                dataTmp.phone.valid = "Requis";
                validation = false;
            } else if (!validPhone(data.phone.value)) {
                dataTmp.phone.valid = "Numéro invalide";
                validation = false;
            }
            //Champs requis
            if (!validEmpty(data.name.value)) {
                dataTmp.name.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.firstname.value)) {
                dataTmp.firstname.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.street.value)) {
                dataTmp.street.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.streetNb.value)) {
                dataTmp.streetNb.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.postalCode.value)) {
                dataTmp.postalCode.valid = "Requis";
                validation = false;
            }
            if (!validEmpty(data.country.value)) {
                dataTmp.country.valid = "Requis";
                validation = false;
            }
            setData(dataTmp);
            return validation;
        }

        if (validateField()) {
            setTab(3);
        }

    }

    const setTab4 = () => {

        const validateField = () => {
            let validation = true;
            let dataTmp = { ...data };
            //Champs requis
            if (!validEmpty(data.orgNb.value)) {
                dataTmp.orgNb.valid = "Requis";
                validation = false;
            }
            dataTmp.structureVete.forEach((item) => {
                if (!validEmpty(item.name.value)) {
                    item.name.valid = "Requis";
                    validation = false;
                }
                if (!validEmpty(item.address.value)) {
                    item.address.valid = "Requis";
                    validation = false;
                }
            })
            setData(dataTmp);
            return validation;
        }

        if (validateField()) {
            setTab(4);
        }
    }

    const submit = () => {

        const validateField = () => {
            let validation = true;
            let dataTmp = { ...data };
            //Champs requis
            if (!validEmpty(data.patient_result_preference.value)) {
                dataTmp.patient_result_preference.valid = "Requis";
                validation = false;
            }
            if (data.cg.value !== true) {
                dataTmp.cg.valid = "Obligatoire";
                validation = false;
            }
            setData(dataTmp);
            return validation;
        }

        const formatData = () => {

            const struct = (item) => {
                return ({
                    name: item.name.value === "" ? null : item.name.value,
                    address: item.address.value === "" ? null : item.address.value,
                    role: item.app_role.value
                })
            }

            const formattedData = {
                first_name: data.firstname.value === "" ? null : data.firstname.value,
                last_name: data.name.value === "" ? null : data.name.value,
                password: data.password.value === "" ? null : data.password.value,
                email: data.email.value === "" ? null : data.email.value,
                language: "FR",
                box: data.box.value === "" ? null : data.box.value,
                country: Number.parseInt(data.country.value),
                postal_code: data.postalCode.value === "" ? null : data.postalCode.value,
                street: data.street.value === "" ? null : data.street.value,
                number: data.streetNb.value === "" ? null : data.streetNb.value,
                phone: data.phone.value === "" ? null : data.phone.value,
                approval_number: data.orgNb.value === "" ? null : data.orgNb.value,
                structures: data.structureVete.map((item) => struct(item)),
                patient_result_preference: Number.parseInt(data.patient_result_preference.value),
                urgency_preferences: data.urgent_result_preference.value,
                required_conditions: data.cg.value === "" ? null : data.cg.value,
                newsletter: data.newsletter.value === "" ? null : data.newsletter.value
            }

            console.log(data.country);
            return formattedData;
        }

        const pushData = () => {


            const xhttp = new XMLHttpRequest();
            document.getElementById("loading").style.display = "flex";
            xhttp.onload = function () {
                if (xhttp.status >= 200 && xhttp.status < 300) {
                    document.getElementById("loading").style.display = "none";
                    setDisplayAlertWindow(true);
                } else {
                    document.getElementById("loading").style.display = "none";
                    window.alert(this.responseText);
                }
            }
            xhttp.open("POST", process.env.REACT_APP_API_URL + "account", process.env.REACT_APP_API_HTTPS);
            xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhttp.send(JSON.stringify(formatData()));
        }

        if (validateField()) {
            pushData();
        }

    }

    const handleNextTab = () => {
        if (tab === 1) {
            setTab2();
        } else if (tab === 2) {
            setTab3();
        } else if (tab === 3) {
            setTab4();
        } else if (tab === 4) {
            submit();
        }
    }

    return (
        <div className="flex flex-row items-center">
            <AlertWindow display={displayAlertWindow} links={[{href:()=>setDisplayAlertWindow(false),txt: "Fermer"}]} msg="Votre demande d'inscription a bien été envoyée. Notre équipe la validera dans les plus brefs délais." />
            <NextArrow direction="previous" display={tab === 1 ? "hide" : ""} handleClick={() => setTab(tab - 1)} />
            <div className="m-5 box-container w-80 min-h-[600px] max-h-[860px] flex flex-col overflow-hidden">
                <img className="p-5" src="/iconslimsvet/logo.png" alt="logo"></img>
                <div className="flex h-10">
                    <Link className="cursor-pointer hover:bg-[#f5f5f5] w-1/2 flex text-gray font-medium text-lg justify-center items-center" to="/">Connexion</Link>
                    <div className="cursor-pointer hover:bg-[#f5f5f5] w-1/2 flex border-b font-medium text-lg justify-center items-center">Inscription</div>
                </div>
                <div className="flex overflow-hidden" onKeyDown={(e) => { if (e.key === "Enter") handleNextTab() }}>
                    {tab === 1 ? <Tab1 data={data} setData={setData} /> : ""}
                    {tab === 2 ? <Tab2 data={data} setData={setData} /> : ""}
                    {tab === 3 ? <Tab3 data={data} setData={setData} /> : ""}
                    {tab === 4 ? <Tab4 data={data} setData={setData} /> : ""}
                </div>
                {tab !== 4 ? <div className="text-white font-medium text-lg bg-light-green grow max-h-16 min-h-16 mt-auto text-center cursor-pointer flex justify-center items-center mt-3" onClick={handleNextTab}>Suivant &gt;</div> : ""}
                {tab === 4 ? <div className="text-white font-medium text-lg bg-red grow max-h-16 min-h-16 mt-auto text-center cursor-pointer flex justify-center items-center mt-3" onClick={handleNextTab}>Inscription &gt;</div> : ""}
            </div>
            <NextArrow display={tab === 4 ? "hide" : ""} handleClick={handleNextTab} />
        </div>
    );
}
function Tab1({ data, setData }) {

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: {
                value: value,
                valid: ""
            }
        })
    }

    return (
        <div className="flex flex-col gap-2 m-3">
            <h2 className="text-base">Informations de connexion</h2>
            <form className="flex flex-col gap-3">
                <InputText placeholder="Email" name="email" validationLabel={data.email.valid} value={data.email.value} onChange={handleChange} label="La création du compte est personnelle, merci d’utiliser une adresse e-mail nominative. Vous aurez ensuite accès à tous les dossiers de votre structure." />
                <InputText password={true} name="password" value={data.password.value} onChange={handleChange} placeholder="Mot de passe*" validationLabel={data.password.valid} label="*Minimum 8 caractères,1 symbole (!@#$%^&*?+-=), 1 chiffre et 1 lettre majuscule." />
            </form>
        </div>
    );
}
function Tab2({ data, setData }) {

    const navigate = useNavigate();

    const [countries, setCountries] = useState([]);
    useEffect(() => { loadCountries(setCountries, navigate) }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: {
                value: value,
                valid: ""
            }
        })
    }
    const handlePhoneChange = value => {
        setData(prevData => ({
            ...prevData,
            phone: {
                value: value,
                valid: ""
            }
        }));
    }

    return (
        <div className="flex flex-col gap-2 m-3">
            <h2 className="text-base">Coordonnées</h2>
            <form className="flex flex-col gap-3">
                <InputText name="name" value={data.name.value} onChange={handleChange} placeholder="Nom" validationLabel={data.name.valid} />
                <InputText validationLabel={data.firstname.valid} name="firstname" value={data.firstname.value} onChange={handleChange} placeholder="Prénom" />
                <InputPhone validationLabel={data.phone.valid} onChange={handlePhoneChange} value={data.phone.value} name="phone" placeholder="Téléphone" />
                <InputText validationLabel={data.street.valid} name="street" value={data.street.value} onChange={handleChange} placeholder="Rue" />
                <div className="flex gap-3">
                    <InputText validationLabel={data.streetNb.valid} name="streetNb" value={data.streetNb.value} onChange={handleChange} placeholder="N°" />
                    <InputText validationLabel={data.box.valid} name="box" value={data.box.value} onChange={handleChange} placeholder="Boîte" />
                </div>
                <div className="flex gap-3">
                    <InputText validationLabel={data.postalCode.valid} name="postalCode" value={data.postalCode.value} onChange={handleChange} placeholder="Code postal" />
                    <InputSelect validationLabel={data.country.valid} name="country" onChange={handleChange} defaultValue={data.country.value} placeholder="Pays" options={countries} />
                </div>
            </form>
        </div>
    )
}
function Tab3({ data, setData }) {

    const handleStructureVetCheckBox = (e) => {
        if (e.target.checked) {
            setData(
                {
                    ...data,
                    structureVete: [{
                        id: crypto.randomUUID(),
                        name: {
                            value: "",
                            valid: ""
                        },
                        address: {
                            value: "",
                            valid: ""
                        },
                        app_role: {
                            value: "STRUCTURE_USER",
                            valid: ""
                        }
                    }]
                });
        }
        else {
            setData(
                {
                    ...data,
                    structureVete: []
                })
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: {
                value: value,
                valid: ""
            }
        })
    }

    const handleAddStructure = () => {

        const array = data.structureVete.concat({
            id: crypto.randomUUID(),
            name: {
                value: "",
                valid: ""
            },
            address: {
                value: "",
                valid: ""
            },
            app_role: {
                value: "STRUCTURE_USER",
                valid: ""
            }
        })
        setData({
            ...data,
            structureVete: array
        },);
    }

    return (
        <div className="flex flex-col w-full overflow-hidden">
            <div className="flex flex-col gap-2 m-3">
                <h2 className="text-base">Informations professionnelles</h2>
                <form>
                    <InputText validationLabel={data.orgNb.valid} name="orgNb" value={data.orgNb.value} onChange={handleChange} placeholder="Numéro d'inscription à l'ordre" />
                </form>
                <div className="flex items-center">
                    <input className="mr-3 size-4" type="checkbox" id="structureVete" name="structureVete" onChange={handleStructureVetCheckBox} />
                    <label className="text-sm text-dark-green" htmlFor="structureVete">Je fais partie d'une structure vétérinaire</label>
                </div>
            </div>
            <div className={"border-t p-3 border-light-gray flex flex-col items-center gap-4 overflow-y-auto" + (data.structureVete.length > 0 ? "" : " hidden")}>
                {data.structureVete.map((item, id) => <StructureVete key={item.id} data={data} setData={setData} id={id} />)}
                <div className="relative duration-500 hover:bg-light-green min-h-14 min-w-14 max-h-14 max-w-14 cursor-pointer border-[3px] border-light-green rounded-full flex justify-center items-center" onClick={handleAddStructure}>
                    <p className="text-4xl font-light -translate-y-1 hover:text-white">+</p>
                </div>
            </div>
        </div>
    );
}
function Tab4({ data, setData }) {

    const navigate = useNavigate();

    const [patientResultPref, setPatientResultPref] = useState([]);
    useEffect(() => { loadPatientResultPref(setPatientResultPref, navigate) }, [navigate]);

    const [urgentResultPref, setUrgentResultPref] = useState([]);
    useEffect(() => { loadUrgentResultPref(setUrgentResultPref, navigate) }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: {
                value: value,
                valid: ""
            }
        })
    }

    const handleURP = (e) => {
        const value = Number.parseInt(e.target.value);
        if (data.urgent_result_preference.value.includes(value)) {
            const index = data.urgent_result_preference.value.indexOf(value);
            setData({
                ...data,
                urgent_result_preference: {
                    value: data.urgent_result_preference.value.toSpliced(index, 1),
                    valid: ""
                }
            })
        } else {
            setData({
                ...data,
                urgent_result_preference: {
                    value: data.urgent_result_preference.value.concat(value),
                    valid: ""
                }
            })
        }

    }

    const handleCG = (e) => {
        const { name, checked } = e.target;
        setData({
            ...data,
            [name]: {
                value: checked,
                valid: ""
            }
        })
    }


    return (
        <div className="flex flex-col gap-2 m-3 text-dark-green text-sm">
            <h2 className="text-base">Préférences</h2>
            <form className="flex flex-col gap-3">
                <legend className="">Délai d'accessibilité des résultats par le propriétaire: (uniquement lorsque le dossier est payé)</legend>
                <InputSelect defaultValue={data.patient_result_preference.value} options={patientResultPref} validationLabel={data.patient_result_preference.valid} placeholder="Délai résultats propriétaire" name="patient_result_preference" onChange={handleChange} />
                <div className="">
                    <legend>Communication des résultats: (plusieurs options possibles)</legend>
                    {urgentResultPref.map((item) => <div key={item.id}><input className="mr-3" name={item.label} id={item.label} value={item.id} type="checkbox" onChange={handleURP} /><label htmlFor={item.label}>{item.label}</label></div>)}
                </div>

                <div><input className="mr-3" name="cg" id="cg" value={data.cg.value} type="checkbox" onChange={handleCG} /><label className={data.cg.valid !== "" ? "text-red" : ""} htmlFor="cg">J'accepte les conditions générales de service* (<a className="underline" href="http://www.limsvet.be/cgs">www.limsvet.be/cgs</a>), les conditions générales d'utilisation* (<a className="underline" href="http://www.limsvet.be/cgu">www.limsvet.be/cgu</a>) et la charte de la vie privée* (<a className="underline" href="http://www.limsvet.be/rgpd">www.limsvet.be/rgpd</a>).</label></div>
                <div><input className="mr-3" name="newsletter" id="newsletter" value={data.newsletter.value} type="checkbox" onChange={handleCG} /><label htmlFor="newsletter">J'accepte de m'abonner à la newsletter de Limsvet pour être informé.e des nouveautés et des formations.</label></div>
                <p className="">*Obligatoire</p>
            </form >
        </div>
    );
}
function StructureVete({ data, setData, id }) {

    const handleChange = e => {
        const { name, value } = e.target;
        let newValue = data.structureVete;
        switch (name) {
            case "structureName":
                newValue[id].name = {
                    value: value,
                    valid: ""
                }
                break;
            case "structureAddress":
                newValue[id].address = {
                    value: value,
                    valid: ""
                }
                break;
            default:
                break;
        }
        setData({
            ...data,
            structureVete: newValue
        });
    }

    const handleChangeRole = e => {
        const { checked, value } = e.target;
        let newValue = data.structureVete;
        if (value === "app_user" && checked === true) {
            newValue[id].app_role = {
                value: "STRUCTURE_USER",
                valid: ""
            }
        } else if (value === "app_admin" && checked === true) {
            newValue[id].app_role = {
                value: "STRUCTURE_ADMIN",
                valid: ""
            }
        }
        setData({
            ...data,
            structureVete: newValue
        })
        console.log(id);
    }

    const handleDelete = () => {
        let newValue = data.structureVete.toSpliced(id, 1);
        setData({
            ...data,
            structureVete: newValue
        })
    }

    return (
        <form className="relative border-2 border-light-green rounded-xl p-3 mt-1 flex flex-col gap-2">
            {id === 0 ? "" : <img className="absolute size-8 z-50 -top-4 right-2 cursor-pointer" src="./cross-delete.svg" alt="delete" onClick={handleDelete} />}
            <p className="absolute -top-4 left-3 px-1 font-medium text-dark-green bg-white z-50">Structure vétérinaire</p>
            <InputText validationLabel={data.structureVete[id].name.valid} name="structureName" value={data.structureVete[id].name.value} onChange={handleChange} placeholder="Nom structure (+TVA)" />
            <InputText validationLabel={data.structureVete[id].address.valid} name="structureAddress" value={data.structureVete[id].address.value} onChange={handleChange} placeholder="Adresse structure" />
            <div>
                <div>
                    <input className="mr-3" type="radio" name="app_role" id={"user" + id} value="app_user" onChange={handleChangeRole} checked={data.structureVete[id].app_role.value === "STRUCTURE_USER" ? true : false} />
                    <label className="text-sm text-dark-green" htmlFor={"user" + id}>Prescripteur</label>
                </div>
                <div>
                    <input className="mr-3" type="radio" name="app_role" id={"admin" + id} value="app_admin" onChange={handleChangeRole} checked={data.structureVete[id].app_role.value === "STRUCTURE_ADMIN" ? true : false} />
                    <label className="text-sm text-dark-green" htmlFor={"admin" + id}>Administrateur de structure vétérinaire</label>
                </div>
            </div>
        </form>
    );
}
